import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';
import { PatientSearchResult } from '@model/patient/patient.model';
import {
  ManualEntryPayload,
  ManualEntryResponse,
  ReprocessPayload
} from '@model/patient/sample-entry.model';

export abstract class PatientPort {
  abstract searchPatient(params: {
    identifierType: string;
    idNumber: string;
  }): Observable<PatientSearchResult>;

  abstract searchByCode(specimenCode: string): Observable<PatientSearchResult>;

  abstract saveSampleByCode(caseNumber: string, payload: any): Observable<any>;

  abstract saveManualSample(
    payload: ManualEntryPayload
  ): Observable<ManualEntryResponse>;

  abstract getSampleByCaseNumber(
    caseNumber: string
  ): Observable<ManualEntryPayload>;

  abstract updateSample(
    caseNumber: string,
    payload: ManualEntryPayload
  ): Observable<any>;

  abstract deleteSample(specimenCode: string): Observable<void>;

  abstract saveReprocess(
    specimenCode: string,
    payload: ReprocessPayload
  ): Observable<void>;

  abstract getSpecimenTypes(): Observable<{ id: string; name: string }[]>;
}

export const PATIENT_PORT = new InjectionToken<PatientPort>('PatientPort');
